import { RequestsStates } from "../../../data/enums/requestsStates";
import { OperationRequestData } from "../../../data/operationRequestData";
import { ActionStateEnum } from "../../../models/enums/operStateEnum";
import { AccountInDefaultModel } from "../../../models/settings/accountInDefaultModel";
import { inject, injectable } from "inversify";
import IAlertService from "../../alert/IAlertService";
import { DiTokens } from "../../diTokens";
import IErrorService from "../../error/IErrorService";
import BaseOperationService from "../../operations/BaseOperationService";
import { ConfigStore } from "../../../store/modules/config";
import { PersonStore } from "../../../store/modules/person";
import i18n from "@/i18n";
import { getModule } from "vuex-module-decorators";
import storeAccessor from "../../../store/storeAccessor";
import { C2BBindingOperationModel } from "../../../models/operations/sbp/C2BBindingOperationModel";
import { OperationsApi } from "../../api/OperationsApi";

/**Сервис установки счета по умолчанию */
@injectable()
export default class C2BBindingOperationService extends BaseOperationService {
  constructor(
    @inject(DiTokens.AlertService) public alertService: IAlertService,
    @inject(DiTokens.ErrorService) public errorService: IErrorService
  ) {
    super(alertService, errorService);
  }

  public personStore!: PersonStore;
  public configStore!: ConfigStore;
  /**
   * Инициализация операции
   * @param initData Данные для инициализации
   * */
  public async init(
    configStore: ConfigStore,
    personStore: PersonStore,
    qrId: string): Promise<C2BBindingOperationModel> {
    this.personStore = personStore;
    this.configStore = configStore;
    await this.personStore.fetchPersonInfo();
    await this.configStore.fetchApiState();
    const operationData = new C2BBindingOperationModel(this.personStore.personInfo, qrId, new OperationRequestData());
    try {
      
      if (!this.configStore.apiData.OperationCodeOfSetSbpC2BBinding) {
        throw Error('Не поддерживается привязка счета C2B.');
      }
      operationData.RespondentCode =
        this.configStore.apiData.OperationCodeOfSetSbpC2BBinding;

      let ord: OperationRequestData = await operationData.createOperationRequest();
      ord = await OperationsApi.executeOperationSendAsync(ord);
      operationData.setOperationFromRequest(ord);

    } catch (e) {
      await this.errorService.errorHandler(e, false, true, "");
    }
    return operationData;
  }

  public async nextStep(model: C2BBindingOperationModel): Promise<C2BBindingOperationModel> {
    let errorText: string = "";
    if (!model.DebitAccount) {
      errorText += "Выберите счет списания. <br/>";
    }

    if (!model.EnableSbpOut) {
      errorText += "Необходимо предоставить согласие на исходящие переводы. <br/>";
    }

    if (!errorText)
      return (await super.execute(model)) as C2BBindingOperationModel;
    else {
      this.alertService.sbp(errorText);
      return model;
    }
  }
  /**
   * Действия после проведения операции
   */
  public async afterExecute(model: C2BBindingOperationModel): Promise<void> {
    this.personStore.personInfo.Data.EnableSbpIn = model.EnableSbpIn;
    this.personStore.personInfo.Data.EnableSbpOut = model.EnableSbpOut;
    this.alertService.sbp("Привязка счета оформлена");
  }

  /**Вычисляем статус операции после выполнения */
  public async analyzeState(
    model: C2BBindingOperationModel,
    ord: OperationRequestData
  ): Promise<C2BBindingOperationModel> {
    model._actionState =
      ord.requestState == RequestsStates.Executed ||
        ord.requestState == RequestsStates.None
        ? ActionStateEnum.Success
        : [3, 6, 7].indexOf(ord.requestState as number)
          ? ActionStateEnum.Error
          : ActionStateEnum.Executing;
    model.ActionStateText = ord.requestStateDescription;
    return model;
  }
}

